import {
  PaymentElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import { StripePaymentElementChangeEvent } from '@stripe/stripe-js';
import { FC } from 'react';

type PaymentElementFormProps = {
  onPaymentElementChange: (event: StripePaymentElementChangeEvent) => void;
};

export const PaymentElementForm: FC<PaymentElementFormProps> = ({
  onPaymentElementChange,
}) => {
  const stripe = useStripe();
  const elements = useElements();

  const handleChange = async (event: StripePaymentElementChangeEvent) => {
    if (!stripe || !elements || !event.complete) {
      return;
    }

    onPaymentElementChange(event);
  };

  return (
    <div>
      <PaymentElement
        onChange={handleChange}
        options={{
          terms: {
            card: 'never',
          },
          fields: {
            // 国は選択させず、一律JPとして扱う
            // 郵便番号が人によって必須になる挙動が発生したので、常に不要とする
            billingDetails: {
              address: {
                country: 'never',
                postalCode: 'never',
              },
            },
          },
          wallets: {
            googlePay: 'never',
            applePay: 'never',
          },
        }}
        className="w-full"
        id="card-element"
      />
    </div>
  );
};
